module.exports = __webpack_public_path__ + "e90cb014b637ef35eabc1334271407a0.svg";